import { ArrowRight, IdCard, User } from 'lucide-react';
import { FC, useState } from 'react';

import Field from '~components/ui/Field';
import Form from '~components/ui/Form';
import Input from '~components/ui/Input';
import Loading from '~components/ui/Loading';
import Notification from '~components/ui/Notification';
import { getFromAPI } from '~utils/api/common';

export interface CollaboratorInfo {
  employeeNumber: string;
  lastName: string;
}

interface Props {
  onContinue: (data: CollaboratorInfo) => void;
}

const CollaboratorInfoForm: FC<Props> = ({ onContinue }) => {
  const [loading, setLoading] = useState(false);
  const form = Form.useForm<CollaboratorInfo>();

  const handleSubmit = (data: CollaboratorInfo) => {
    setLoading(true);
    const searchParams = new URLSearchParams();
    searchParams.append('employeeNumber', data.employeeNumber);
    searchParams.append('lastName', data.lastName.trim());
    getFromAPI(`/uas-collaborators/search?${searchParams.toString()}`, { notifyErrors: false })
      .then(() => {
        onContinue({
          employeeNumber: data.employeeNumber,
          lastName: data.lastName.trim(),
        });
      })
      .catch((e) => {
        Notification.error({
          title: e.message,
          message: 'Verifica tu información',
          placement: 'top',
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Loading show={loading} size="normal" label="Validando información">
      <div className="flex max-w-2xl flex-col items-center gap-6 px-6 py-8 md:px-8">
        <span className="rounded-full bg-primary/5 p-4 text-primary dark:bg-primary/20">
          <IdCard size={32} />
        </span>
        <div>
          <h1 className="h3 text-center font-bold">Información Laboral</h1>
          <p className="text-support">
            Ingresa tus datos para verificar tu identidad como colaborador UAS
          </p>
        </div>
        <Form form={form} onSubmit={handleSubmit} className="flex w-full flex-col gap-4">
          <Field
            name="employeeNumber"
            label={
              <span className="flex items-center gap-2">
                <IdCard />
                <span>Número de empleado</span>
              </span>
            }
            help="Ingresa tu número de empleado UAS."
            rules={{ required: true, message: 'Ingresa tu número de empleado' }}
          >
            <Input type="number" placeholder="EJ: 12345" />
          </Field>
          <Field
            name="lastName"
            label={
              <span className="flex items-center gap-2">
                <User />
                <span>Primer apellido</span>
              </span>
            }
            help="Escribe tu primer apellido tal como aparece en el registro UAS."
            rules={{ required: true, message: 'Ingresa tu primer apellido' }}
          >
            <Input placeholder="Pérez" />
          </Field>
          <button className="btn btn-primary w-full" type="submit">
            <span>Continuar</span> <ArrowRight size={16} />
          </button>
        </Form>
      </div>
    </Loading>
  );
};

export default CollaboratorInfoForm;
